import { b as _defineProperty, _ as _getPrototypeOf, a as _possibleConstructorReturn, c as _inherits, d as _classCallCheck, e as _createClass, Q } from '../_chunks/dep-b05afc19.js';
import { IconBase } from '../icon.js';
import '../util/classname.js';
import '../util/size-props.js';
import '../util/check-url-and-load.js';

var _class;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
var element = {
  "attributes": {
    "fill": "none",
    "viewBox": "0 0 24 24",
    "width": "1em",
    "height": "1em"
  },
  "nodeName": "svg",
  "children": [{
    "attributes": {
      "id": "browse-off"
    },
    "nodeName": "g",
    "children": [{
      "attributes": {
        "id": "stroke1",
        "stroke": "currentColor",
        "d": "M13.1758 8.17578C14.4396 8.56376 15.4368 9.56096 15.8247 10.8247M21.2858 15.2856C22.0085 14.2983 22.5776 13.1913 22.9578 12C21.4771 7.36017 17.131 4 12.0001 4C11.3698 4 10.7513 4.05072 10.1484 4.1483M5.80747 5.80786C3.57225 7.23888 1.86478 9.42193 1.04199 12.0001C2.52275 16.6399 6.86881 20.0001 11.9997 20.0001C14.2796 20.0001 16.4045 19.3367 18.1919 18.1923L5.80747 5.80786ZM8 12.0003C8 10.8957 8.44771 9.89573 9.17157 9.17188L14.8284 14.8287C14.1046 15.5526 13.1046 16.0003 12 16.0003C9.79086 16.0003 8 14.2094 8 12.0003Z",
        "stroke-linecap": "square",
        "stroke-width": 2
      },
      "nodeName": "path",
      "children": []
    }, {
      "attributes": {
        "id": "stroke2",
        "stroke": "currentColor",
        "d": "M20.9996 21L3 3",
        "stroke-linecap": "square",
        "stroke-width": 2
      },
      "nodeName": "path",
      "children": []
    }]
  }]
};
var BrowseOffIcon = (_class = /*#__PURE__*/function (_IconBase) {
  _inherits(BrowseOffIcon, _IconBase);
  var _super = _createSuper(BrowseOffIcon);
  function BrowseOffIcon() {
    var _this;
    _classCallCheck(this, BrowseOffIcon);
    _this = _super.call(this);
    _this.props = _objectSpread(_objectSpread({}, _this.props), {}, {
      id: "browse-off"
    });
    return _this;
  }
  return _createClass(BrowseOffIcon);
}(IconBase), _defineProperty(_class, "icon", element), _class);
BrowseOffIcon = __decorateClass([Q("t-icon-browse-off")], BrowseOffIcon);

export default BrowseOffIcon;
//# sourceMappingURL=browse-off.js.map
